import { useRef, useCallback } from 'react';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import styles from './Input.module.css';

const ARROW_BASE_STYLES = {
    position: 'absolute',
    right: '0rem',
    bottom: '0rem',
    color: 'rgba(0, 0, 0, 0.5)',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
};

function Input({
    id,
    name,
    disabled,
    value,
    type,
    placeholder,
    autoFocus,
    defaultValue,
    onChange,
    onBlur,
    inputStyles,
    inputProps,
    setFocused,
    // automation,
    onFocus,
    focused,
    dropdownArrow,
}) {
    const inputRef = useRef();
    const isBlurringRef = useRef(false);

    const handleFocus = useCallback(() => {
        isBlurringRef.current = false;
        setFocused(true);
        onFocus && onFocus(true);
    }, [onFocus, setFocused]);

    const handleBlur = useCallback(
        (e) => {
            if (e.relatedTarget === inputRef.current || isBlurringRef.current) {
                return;
            }

            isBlurringRef.current = true;
            setFocused(false);
            onFocus?.(false);
            onBlur?.(e);
            isBlurringRef.current = false;
        },
        [onBlur, onFocus, setFocused]
    );

    //TODO make textarea as separate input component and/or make it truly resuable (time pressure forces current kind of solution)

    const inputStyle = dropdownArrow ? { paddingRight: '1rem', textOverflow: 'ellipsis' } : {};

    const input =
        type === 'textarea' ? (
            <textarea id={id} name={name} disabled={disabled} className={inputStyles} value={value} {...inputProps} />
        ) : (
            <input
                id={id}
                name={name}
                disabled={disabled}
                className={inputStyles}
                style={inputStyle}
                value={value}
                type={type}
                onChange={onChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                placeholder={placeholder}
                autoFocus={autoFocus}
                defaultValue={defaultValue}
                autoComplete="one-time-code"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                {...inputProps}
                ref={inputRef}
            />
        );
    return (
        <div className={styles['input-wrapper']}>
            {input}
            {dropdownArrow && (
                <ArrowDropDownRoundedIcon
                    sx={{
                        ...ARROW_BASE_STYLES,
                        transform: focused ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => inputRef.current.focus()}
                />
            )}
        </div>
    );
}

export default Input;
